/**
 * (Группа 11) Здоровье платформы и мониторинг.
 *
 * REAL частично: GET /v1/admin/workflows (Temporal workflows, process_engine).
 * Агрегированный health-дашборд (6 компонентов) — TODO backend
 * (/v1/platform/health отсутствует).
 */
import { PageStub } from '../../shared/PageStub.js';

export function HealthPage(): JSX.Element {
  return (
    <PageStub
      testId="health-page"
      title="Здоровье платформы"
      description="Состояние компонентов, фоновые задачи, миграции, фиче-тогглы, шаблоны писем."
      sections={[
        'Дашборд здоровья: API, Postgres, Temporal, MinIO, Email, Telegram (спарклайн 28 дней)',
        'Drill-down логов компонента (последние 30 минут)',
        'Статус Temporal workflows: running / backlog / stuck / failed',
        'Per-tenant миграции: версия схемы, ожидающие, кнопка применить',
        'Фиче-тогглы: runtime-переопределения capability per-tenant',
        'Шаблоны писем: 6 ключей (invite, signed-link, invoice, review, vendor, recovery)',
      ]}
      dataSource="REAL GET /v1/admin/workflows (Temporal); агрегированный health — TODO backend (/v1/platform/health)"
    />
  );
}
